import { FC } from "react";
import styles from "./Navigation.module.css";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { NavItemSchema } from "../../data/validators";
import { DataErrorBoundary } from "../error/DataErrorBoundary";
import ErrorComponent from "../error/ErrorComponent";
import navigationData from "../../data/navigation.json";

const navItems = NavItemSchema.array().parse(navigationData);

const Navigation: FC = () => (
  <DataErrorBoundary fallback={<ErrorComponent />}>
    <Navbar expand="lg" variant="dark" bg="dark" fixed="top">
      <Container>
        <Navbar.Brand href="#" className={styles.brand}>
          tamarillo
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          <Nav className="ms-auto">
            {navItems.map((item) => (
              <Nav.Link
                key={item.href}
                href={item.href}
                className={styles.navLink}
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </DataErrorBoundary>
);

export default Navigation;
